/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ProgressBar extends Component {
    static propTypes = {
        min: PropTypes.number,
        max: PropTypes.number,
        value: PropTypes.number,
        type: PropTypes.oneOf(['default', 'animated']),
        alignLabel: PropTypes.oneOf(['left', 'center', 'right']),
        labelText: PropTypes.string,
        id: PropTypes.string.isRequired
    };

    static defaultProps = {
        min: 0,
        max: 100,
        value: 0,
        type: 'default',
        alignLabel: 'center'
    };

    calculateRatio() {
        if (this.props.value < this.props.min) { return this.props.min; }
        if (this.props.value > this.props.max) { return this.props.max; }
        return Math.round((this.props.value - this.props.min) / (this.props.max - this.props.min) * 100);
    }

    render() {
        const { min, max, type, alignLabel, labelText, id } = this.props;

        return (
            <div className={`progress-bar-container progress-bar-text-${alignLabel}`}>
                <span className="pe-progress-bar-rail">
                    <div
                        id={id}
                        className={type === 'animated' ? 'pe-progress-bar pb-animated' : 'pe-progress-bar'}
                        tabIndex="-1"
                        role="progressbar"
                        aria-valuemin={min}
                        aria-valuemax={max}
                        aria-valuenow={this.calculateRatio()}
                        style={{width: `${this.calculateRatio()}%`}}
                    />
                </span>
                <label className="pe-textLabelInput__label" htmlFor={id}>
                    {labelText}
                </label>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/ProgressBar/ProgressBar.js